angular.module('core')
    .component('paginationForPage', {
        bindings: {
            page: '<',
            filters: '<',
            onFiltersChange: '&'
        },
        template: `
            <div class="text-right">
                <ul ng-if="$ctrl.page && $ctrl.page.fullListSize > 0" uib-pagination total-items="$ctrl.page.fullListSize" ng-model="$ctrl.page.pageNumber" ng-change="$ctrl.pageChanged()" max-size="10" boundary-links="true" rotate="true" items-per-page="$ctrl.page.objectsPerPage" class="pagination"></ul>
            </div>
        `,
        controller: function ($location) {
            this.pageChanged = () => {
                if (this.filters) {
                    this.filters.page = this.page.pageNumber
                    this.onFiltersChange();
                } else {
                    delete this.page.list;
                    $location.search("page", this.page.pageNumber);
                }
            };
        }
    })
    .component('pageRowsCount', {
        bindings: {
            page: '<'
        },
        template: ' ({{$ctrl.page.fullListSize >= 0 ? $ctrl.page.fullListSize : \'...\'}})'
    })
